import FooterInfo from './FooterInfo'
export default FooterInfo
